import angular from "angular";

const dirtyClass = "was-modified";

export default angular
.module("energis.databinding", [])
.directive("dBind", function DataBinding($compile){
  return {
    restrict: "A",
    scope:{
      "dBind":"="
    },
    link: function(scope, element, attr){
      if(!attr.ngModel){
        element.attr("ng-model", attr.dBind+".value");
        $compile(element)(scope.$parent);
      }else{
        scope.$watch("dBind.modified", function(isModified){
          if(isModified){
            element.addClass(dirtyClass);
          }else{
            element.removeClass(dirtyClass);
          }
        })
      }
    }    
  }
})
.name


// WEBPACK FOOTER //
// ./src/Editor/DataBinding.js